<template>
    <form class="grid grid-cols-4 row-gap-5  md:row-gap-10 items-center" @submit.prevent="submit">
        <slot></slot>
        <template v-if="remark">
            <div class="col-span-4 md:col-span-1">
                <p class="text-smoke-dark text-sm">Remark</p>
            </div>
            <div class="col-span-4 md:col-span-3">
                <biller-input
                    type="text"
                    placeholder="Reason for payment"
                    v-model="fieldData.reason_for_payment"
                    required
                />
            </div>
        </template>
        <template v-if="!remarkOnly">
            <div class="col-span-4 md:col-span-1">
                <p class="text-smoke-dark text-sm">Voucher (optional)</p>
            </div>
            <div class="col-span-4 md:col-span-3">
                <biller-input
                    type="text"
                    placeholder="Input Voucher/Promo Code"
                    largeValue
                    @input="deboucedGetVoucherDetails"
                    v-model="voucher_code"
                >
                    <template v-slot:append>
                        <template v-if="loadVoucher">
                            <img src="@/assets/svg/load.svg" alt="loader" class="w-6" />
                        </template>
                        <template v-else-if="loadedVoucher">
                            <div class="flex items-center">
                                <p class="text-smoke-dark text-sm pr-4 hidden md:block">
                                    ₦{{ voucher.amount || formatAmount }} Voucher Applied
                                </p>
                                <img src="@/assets/svg/check.svg" alt="loader" class="w-5" />
                            </div>
                        </template>
                    </template>
                </biller-input>
            </div>
        </template>

        <div class="col-span-4"></div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm pb-5">User Information</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-2 gap-5 md:gap-10">
                <div class="col-span-2 md:col-span-1">
                    <biller-input type="number" placeholder="Phone Number" v-model="fieldData.phone" required>
                    </biller-input>
                </div>
                <div class="col-span-2 md:col-span-1">
                    <biller-input type="email" placeholder="Email Address" v-model="fieldData.email" required />
                </div>
            </div>
            <div class="flex items-center mt-3">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8 5.6C7.5584 5.6 7.2 5.2416 7.2 4.8C7.2 4.3584 7.5584 4 8 4C8.4416 4 8.8 4.3584 8.8 4.8C8.8 5.2416 8.4416 5.6 8 5.6ZM8.8 11.2C8.8 11.6416 8.4416 12 8 12C7.5584 12 7.2 11.6416 7.2 11.2V7.2C7.2 6.7584 7.5584 6.4 8 6.4C8.4416 6.4 8.8 6.7584 8.8 7.2V11.2ZM8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4176 16 16 12.4184 16 8C16 3.5816 12.4176 0 8 0Z"
                        fill="#9DA8B6"
                    />
                </svg>
                <p class="text-xs text-smoke-dark">
                    We need these information so we can send you receipt of your transaction.
                </p>
            </div>
        </div>
        <div class="col-span-4 md:col-span-1"></div>
        <div class="col-span-4 md:col-span-2 flex items-center">
            <button class="text-white text-lg font-medium py-4 px-16 rounded-lg bg-orange md:w-auto w-full mr-4">
                Continue
            </button>
            <img src="@/assets/svg/load.svg" alt="loader" class="w-8" v-show="showLoader" />
        </div>
    </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { verifyVoucher } from '@/api/voucher'
import { formatAmount } from '@/util/formatAmount'
import { debounce } from '@/util/debounce'
export default {
    props: {
        remark: {
            type: Boolean,
            default: false,
        },
        remarkOnly: {
            type: Boolean,
            default: false,
        },
        showLoader: Boolean,
    },
    data() {
        return {
            loadVoucher: false,
            loadedVoucher: false,
            fieldData: {
                reason_for_payment: '',
                phone: '',
                email: '',
            },
            voucher_code: '',
            voucher: {},
        }
    },
    filters: {
        formatAmount(val) {
            if (val) {
                return formatAmount(val)
            }

            return 0
        },
    },
    created() {
        this.deboucedGetVoucherDetails = debounce(this.getVoucherDetails, 1000)
    },
    computed: {
        ...mapGetters('Countries', {
            active_country: 'GET_ACTIVE_COUNTRY',
        }),
    },

    watch: {
        fieldData: {
            handler(val) {
                if (val.voucher) {
                    this.deboucedGetVoucherDetails()
                }
            },
            deep: true,
        },
    },

    methods: {
        submit() {
            this.$emit('submit', { country_id: this.active_country.id, ...this['fieldData'] })
        },

        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
            setType: 'SET_MESSAGE_TYPE',
        }),

        ...mapActions('Voucher', {
            setVoucher: 'SET_VOUCHER',
        }),

        getVoucherDetails() {
            this.loadVoucher = true
            verifyVoucher(this.voucher_code)
                .then((data) => {
                    this.loadVoucher = false
                    this.loadedVoucher = true
                    this.voucher = data.data.voucher
                    this.fieldData.voucher = data.data.voucher.voucher
                    this.setVoucher(data.data.voucher)
                })
                .catch(() => {
                    this.loadVoucher = false
                    this.loadedVoucher = false
                    this.voucher = {}
                    delete this.fieldData['voucher']
                    this.setMessage('Sorry, Voucher was not found')
                    this.setType(false)
                })
        },
    },
}
</script>

<style></style>
